// extracted by mini-css-extract-plugin
export default {"container":"QSMlvi","ratioImage":"FKfjFz"};